const coloursDefault = (theme) => ({
  authContainer: {
    backgroundColor: theme.color?.neutral?.surfaceDefault,
    foregroundColor: theme.color?.neutral?.surfaceDefault,
    loginContainer: {
      backgroundColor: 'transparent'
    },
    textColor: theme.color?.neutral?.onSurfaceDefault,
  },
  brandColor: theme.color?.brand?.default,
});

export default coloursDefault;
